import { barProgress, type PlayerState } from '@/lib/whats-new/player-reducer';

/** One bar per slide, the current one filling with its time (NEWS-01/03). */
export function ProgressBars({ state }: { state: PlayerState }) {
  return (
    <div aria-hidden="true" className="flex gap-1.5">
      {state.durations.map((_, index) => (
        <span
          key={index}
          className="h-[3px] flex-1 overflow-hidden rounded-[3px] bg-white/20"
        >
          <span
            data-testid="progress-bar-fill"
            className="block h-full rounded-[3px] bg-white"
            style={{ width: `${barProgress(state, index) * 100}%` }}
          />
        </span>
      ))}
    </div>
  );
}
